var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.clazz,on:{"click":function($event){$event.stopPropagation();return _vm.onClick()}}},[_c('font-awesome-icon',{attrs:{"icon":"share-alt","size":_vm.iconSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }